import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import Site from "../../models/Site";
import { SpinnerWrapper } from "../SpinnerWrapper";
import { TextFieldWithButton } from "../TextField";
import { TextFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import OpsDialogImage from "../OpsDialogImage";
import OpsStringUtils from "../../utils/OpsStringUtils";
import { TextField } from "@mui/material";
import { useStyles } from "../Main/formStyles";
import { Token } from "../../theme";

interface Props {
  viewSite: Site;
  onClose: () => void;
  isLoading: boolean;
}

export default function SiteViewDialog(props: Props) {
  const formatRole = props.viewSite.roleName === "ROLE_USER" ? "All" : props.viewSite.roleName.replace("ROLE_", "");
  const formatProjectName = props.viewSite.projectExternalId === "" ? "All projects" : props.viewSite.projectName;
  const customStyles = useStyles();

  return (
    <GenericForm<Site>
      headerStyles={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}
      buttonStyles={{ marginRight: 20, color: "white", backgroundColor: Token.actionPrimary, marginBottom: 10 }}
      cancelButtonStyles={{
        color: Token.textSecondary,
        border: `1px solid ${Token.borderDefault}`,
        marginBottom: 10,
      }}
      dialogStyles={customStyles.root}
      dialog={true}
      open={!!props.viewSite}
      instance={props.viewSite}
      title={`${props.viewSite?.title}`}
      onSave={() => props.onClose()}
      dialogCustomSubmitMessage={"Close"}
      hideCancel={true}
      disableBackdropClick
      renderContent={(register, errors, control) => (
        <>
          <SpinnerWrapper isLoading={props.isLoading}>
            <OpsDialogImage viewMode={!!props.viewSite} selectedFile={props.viewSite?.imageUrl!} onDelete={() => {}} />
            <TextFieldComponent propertyName={"title"} label={"Title"} defaultValue={props.viewSite?.title} readOnly={true} />
            <TextField label={"Role"} defaultValue={OpsStringUtils.capitalize(formatRole)} disabled variant="filled" />
            <TextField label={"Project Name"} defaultValue={formatProjectName} disabled variant="filled" />
            <TextFieldComponent
              propertyName={"priority"}
              label="Priority"
              defaultValue={OpsStringUtils.capitalize(props.viewSite?.priority)}
              readOnly={true}
            />

            <TextFieldComponent
              propertyName={"description"}
              label="Description"
              readOnly={true}
              defaultValue={props.viewSite?.description}
              internalProps={{ multiline: true, rows: 6 }}
              size="small"
            />

            <TextFieldWithButton
              propertyName={"link"}
              label="Link"
              defaultValue={props.viewSite?.link}
              readOnly={true}
              addButton
              onClick={() => window.open(`${props.viewSite?.link}`)}
            />
          </SpinnerWrapper>
        </>
      )}
    />
  );
}
